import classnames from 'classnames/bind'
import React from 'react'

import ImageWithPlaceholder, {
  ImageWithPlaceholderProps,
} from '~/components/ImageWithPlaceholder'
import Ratio from '~/components/Ratio'
import RichText, { RichTextBlock } from '~/components/RichText'

import { useStyle } from '~/providers/StyleProvider'

import css from './styles.module.scss'

const cx = classnames.bind(css)

export const RATIO = 16 / 9

export interface SliderImageProps {
  className?: string
  isActive?: boolean
  image?: ImageWithPlaceholderProps
  text?: RichTextBlock[]
}

function SliderImage({ className, image, text, isActive }: SliderImageProps) {
  const textStyle = useStyle({ textPreset: 'text-paragraph', color: 'ebony' })

  return (
    <div className={cx(css.SliderImage, className, { isActive })}>
      {image && (
        <Ratio className={css.sliderImageWrapper} ratio={RATIO}>
          {(cn) => (
            <ImageWithPlaceholder
              className={css.sliderImage}
              layout="fill"
              objectFit="cover"
              {...image}
            />
          )}
        </Ratio>
      )}
      {text?.length > 0 && (
        <div className={css.sliderImageText}>
          <RichText className={cx(css.text, textStyle)} render={text} />
        </div>
      )}
    </div>
  )
}

SliderImage.defaultProps = {
  isActive: true,
}

export default SliderImage
